// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--VYlMG","info":"_02712f2b3b--info--_pkjJ","title":"_02712f2b3b--title--IdoDE","description":"_02712f2b3b--description--McNp6"};